import { createAsyncThunk } from "@reduxjs/toolkit";
import { onfidoApi } from "../api";
import { ERROR_CODES } from "../constants";
import { onfidoInitialState, setOnfidoState } from "../reducer";
import { TOnfidoParams } from "../types";
import { getOnfidoPhases } from "../utils";
import { StepDefinition } from "onfido-sdk-ui/types/shared/Types";

export const setupOnfidoConfigurations = createAsyncThunk<
  { steps: StepDefinition[]; token: string }[],
  TOnfidoParams
>("onfido/SETUP_CONFIGURATIONS", async (params: TOnfidoParams, thunkApi) => {
  const { dispatch, rejectWithValue } = thunkApi;
  try {
    const response = await dispatch(
      onfidoApi.endpoints.init.initiate({
        name: params.name,
        surname: params.surname,
        ...(import.meta.env.DEV ? { referrer: "http://localhost:3000/" } : {}),
      }),
    ).unwrap();
    const token = response?.sdkToken;
    if (token === null) {
      dispatch(
        setOnfidoState({
          ...onfidoInitialState,
          hasError: true,
        }),
      );
      return rejectWithValue(ERROR_CODES.MISSING_TOKEN);
    }
    const phases = getOnfidoPhases(params, token);
    if (phases.length > 0) {
      dispatch(
        setOnfidoState({
          phases,
          currentPhaseIndex: 0,
        }),
      );
    } else {
      dispatch(
        setOnfidoState({
          ...onfidoInitialState,
          hasError: true,
        }),
      );
    }
    return phases;
  } catch (err) {
    return rejectWithValue(ERROR_CODES.START_GENERIC_ERROR);
  }
});
